import { useLocation } from 'react-router-dom'
import { SeoHead } from '@/components/seo/SeoHead'

export const NotFoundPage = () => {
  const { pathname } = useLocation()

  return (
    <>
      <SeoHead pathname={pathname} kind="not-found" />
      <div className="site-page mx-auto max-w-lg px-6 pt-0 pb-24 text-center md:py-24">
        <h1 className="font-display text-2xl font-semibold text-[var(--foreground)]">Page not found</h1>
        <p className="mt-3 text-[var(--foreground-muted)]">Nothing lives at this path.</p>
        <a
          href="/"
          className="mt-8 inline-block text-sm font-semibold text-[var(--foreground)] underline underline-offset-2"
        >
          Back home
        </a>
      </div>
    </>
  )
}
